import React from 'react';
import { TextField, Grid, MenuItem } from '@mui/material';
import Autocomplite from './Autocomplite'
import { IconButton, InputAdornment } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  adornedEnd: {
    color: "hsl(0, 0%, 80%)",
    "&:hover": { color: 'hsl(0, 0%, 60%)' }
  },
}));
const arr = [{ value: 'year', label: 'Год' }, { value: 'day', label: 'День' }, { value: 'month', label: 'Месяц' }]
export default function FilterDate({ filter, onChange, changeDate, filterDate }) {
  const classes = useStyles();
  return <div >
    <Grid container spacing={2} alignItems='flex-end'>
      <Grid xs={3} item>
        <TextField
          select
          fullWidth
          variant="standard"
          value={filter}
          onChange={(e) => { onChange(e.target.value); }}
          label='Группировка'
        >
          <MenuItem value=""><em>—</em></MenuItem>
          {arr.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item>
        {(filter === "year") ?
          <TextField
            id="date"
            name='date'
            label='Год'
            type="number"
            value={filterDate}
            variant="standard"
            inputProps={{
              min: 2018,
              max: 2099,
              step: 1
            }}
            InputProps={{
              endAdornment: (<InputAdornment position="end">
                <IconButton size="small" className={classes.adornedEnd}
                  onClick={(e) => changeDate({ ...e, target: { value: '' } })}
                ><ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>)
            }}
            onChange={changeDate}
          />
          : <TextField
            id="date"
            name='date'
            type={(filter === "month") ? "month" : "date"}
            label={(filter === "month") ? "Месяц" : "Дата"}
            value={filterDate}
            variant="standard"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (<InputAdornment position="end">
                <IconButton size="small" className={classes.adornedEnd}
                  onClick={(e) => changeDate({ ...e, target: { value: '' } })}
                ><ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>),
            }}
            onChange={changeDate}

          />}
      </Grid>
    </Grid>
  </div>
}